import { Box, Typography } from '@mui/material';

import { PoliceReportsTable } from '../components/police-reports/PoliceReportsTable';
import { useListPoliceReportLookupsQuery } from '../services/api/policeReportsService';

export default function PoliceReports() {
  const { data: lookups, isLoading, error } = useListPoliceReportLookupsQuery();

  if (isLoading) {
    return (
      <Box p={3}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Typography>
          Error loading police report lookups. Please try again later.
        </Typography>
      </Box>
    );
  }

  if (!lookups || !Array.isArray(lookups) || lookups.length === 0) {
    return (
      <Box p={3}>
        <Typography>No police report lookups found</Typography>
      </Box>
    );
  }

  return (
    <Box p={0}>
      <PoliceReportsTable data={lookups} />
    </Box>
  );
}
